import videojs from '@mux/videojs-kit';

const selectedVideoMap = {}

const showSelectedVideo = (selectedOption, input) => {
  let videoElement = input.parent().parent().find('video')
  if (!videoElement[0]) {
    const inputsContainer = input.parent()
    videoElement = $(document.createElement('video'))
    videoElement.addClass('video-js vjs-16-9')
    videoElement.attr('controls', true)
    videoElement.insertAfter(inputsContainer)
  }

  const videoPlayer = videojs(videoElement[0])
  videoPlayer.src({
    src: $(selectedOption.element).data('playbackurl'),
    type: 'video/mux'
  })
  selectedVideoMap[input.attr('id')] = videoPlayer
  let endTimeInput = input.parent().parent().find('li#end_time').find('input')
  if (endTimeInput[0]) {
    endTimeInput[0].value = $(selectedOption.element).data('groupvideoendtime')
  }
  toggleLogoAndInputsVisibility(input, true)
}

const hideVideoPlayer = (input) => {
  const videoPlayer = selectedVideoMap[input.attr('id')]
  if (videoPlayer) {
    videoPlayer.dispose()
    toggleLogoAndInputsVisibility(input, false)
  }
}

const toggleLogoAndInputsVisibility = (input, hidden) => {
  let logoElement = input.parent().parent().find('img#logo')
  if (logoElement[0]) {
    logoElement[0].hidden = hidden;
  }
  let startTime = input.parent().parent().find('li#start_time')
  if (startTime[0]) {
    startTime[0].hidden = !hidden;
  }
  let endTime = input.parent().parent().find('li#end_time')
  if (endTime[0]) {
    endTime[0].hidden = !hidden;
  }
}

$(() => {
  $('.mosaic-customize-select2').each(function() {
    const input = $(this)

    const selectedOption = input.select2('data')[0]
    if (selectedOption && selectedOption.id !== '') {
      showSelectedVideo(selectedOption, input)
    }

    input.on('select2:select', event => {
      if (event.params.data.id !== '') {
        showSelectedVideo(event.params.data, input)
      }
      else {
        hideVideoPlayer(input)
      }
    })
  })
})
